import React from 'react';

const Heading = ({ title, description }) => {
  return (
    <>
      <h1 className="mb-0 f-20 fw-semibold">{title}</h1>
      {description && (
        <p
          className="mt-3"
          style={{ maxWidth: '600px', color: '#333130', fontSize: '14px' }}
        >
          {description}
        </p>
      )}
    </>
  );
};

export default Heading;
